document.addEventListener("DOMContentLoaded", function () {
    const storeNameInput = document.getElementById("store_name");
    const loginCheckInput = document.getElementById("login_check");
    const customerEmailInput = document.getElementById("customer_email");
    const popupContainer = document.getElementById("custom_popup");

    const storeName = storeNameInput ? storeNameInput.value : "";
    const loginCheck = loginCheckInput ? loginCheckInput.value : "0";
    const customerEmail = loginCheck === "1" && customerEmailInput ? customerEmailInput.value : "";

    const requestData = JSON.stringify({
        store_name: storeName,
        login_check: loginCheck,
        customer_email: customerEmail
    });

    function escapeHtml(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
        const cookieName = name + "=";
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length);
            }
        }
        return null;
    }

    function shouldHideByPageVisibility(pageVisibility) {
        const currentUrl = window.location.pathname;
        const blockedPages = ["/pages/kundeklubb", "/a/loyalty"];
        const shopRoot =
            window.Shopify && Shopify.routes && Shopify.routes.root
                ? Shopify.routes.root
                : "/";

        if (Number(pageVisibility) === 2 && currentUrl !== shopRoot) {
            console.log("Popup hidden because this is not the home page.");
            return true;
        }

        if (
            Number(pageVisibility) === 0 &&
            blockedPages.some(function (page) {
                return currentUrl.startsWith(page);
            })
        ) {
            console.log("Popup hidden due to page visibility settings.");
            return true;
        }

        return false;
    }

    function shouldHideByMemberVisibility(memberVisibility, memberCheck) {
        const normalizedMemberVisibility = Number(memberVisibility);
        const isMember = !!memberCheck;
        const isLoggedIn = loginCheck === "1";

        if (normalizedMemberVisibility === 0 && isLoggedIn && isMember) {
            console.log("Popup hidden due to member visibility settings.");
            return true;
        }

        if (normalizedMemberVisibility === 1 && (!isLoggedIn || !isMember)) {
            console.log("Popup will be shown since user is not logged in or not a member.");
        }

        return false;
    }

    function buildPopupHtml(config) {
        const buttonHtml = config.buttonText
            ? `<button type="button" id="modishPopupButton" class="modish-button-link-text">${escapeHtml(config.buttonText)}</button>`
            : `<button type="button" id="modishPopupButton" class="modish-button-link-text modish-button-icon-only" aria-label="Continue">
                    <img src="https://cdn.shopify.com/s/files/1/0567/1380/5987/files/up-arrow-svgrepo-com.svg?v=1708366385" alt="" width="20" height="20">
               </button>`;

        return `
            <div id="modish-popup" class="modish-popup" aria-hidden="true">
                <div class="modish-popup-content" id="modish-popup-content-wrapper">
                    <div class="modish-popup-image-wrapper">
                        <img id="modish-popup-image" src="${escapeHtml(config.image)}" alt="Popup Image">
                    </div>

                    <div class="modish-popup-content-text-wrapper">
                        <button type="button" class="modish-popup-close" aria-label="Close popup">&times;</button>

                        <div class="modish-newsletter-popup-content">
                            <h3 id="modish-pop-header-text">${escapeHtml(config.headerText)}</h3>

                            <div id="modish-pop-description">
                                ${config.description}
                            </div>

                            <form id="modish-popup-form" novalidate>
                                <div class="modish-popup-input-container">
                                    <input type="hidden" id="modish-popup-input-url" value="${escapeHtml(config.buttonUrl)}">
                                    <input
                                        class="modish-input-field"
                                        type="email"
                                        name="email"
                                        id="modish-popup-input-email"
                                        placeholder="${escapeHtml(config.emailPlaceholder)}"
                                        autocomplete="email"
                                    >
                                    ${buttonHtml}
                                </div>
                                <input type="hidden" name="oic" value="shopify_popup">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    function applyDynamicStyles(config) {
        const popupContent = document.getElementById("modish-popup-content-wrapper");
        const header = document.getElementById("modish-pop-header-text");
        const emailInput = document.getElementById("modish-popup-input-email");
        const button = document.getElementById("modishPopupButton");

        if (popupContent) {
            popupContent.style.backgroundColor = config.backgroundColor;
        }

        if (header) {
            header.style.color = config.headerTextColor;
            header.style.fontSize = config.headerTextSize + "px";
        }

        if (emailInput) {
            emailInput.style.backgroundColor = config.emailBgColor;
            emailInput.style.borderColor = config.emailBorderColor;
        }

        if (button) {
            button.style.backgroundColor = config.buttonBgColor;
            button.style.borderColor = config.buttonBgColor;
            button.style.color = config.buttonTextColor;
        }
    }

    function showPopup(useCookies) {
        const popup = document.getElementById("modish-popup");
        if (!popup) return;

        if (!useCookies) {
            if (getCookie("modishPopupShown") !== "true") {
                popup.style.display = "flex";
                popup.setAttribute("aria-hidden", "false");
                setCookie("modishPopupShown", "true", 30);
            }
        } else {
            popup.style.display = "flex";
            popup.setAttribute("aria-hidden", "false");
        }
    }

    function closePopup() {
        const popup = document.getElementById("modish-popup");
        if (!popup) return;

        popup.style.display = "none";
        popup.setAttribute("aria-hidden", "true");
    }

    function bindPopupEvents() {
        const closeButton = document.querySelector(".modish-popup-close");
        const popupButton = document.getElementById("modishPopupButton");
        const popup = document.getElementById("modish-popup");

        if (closeButton) {
            closeButton.addEventListener("click", closePopup);
        }

        if (popup) {
            popup.addEventListener("click", function (e) {
                if (e.target === popup) {
                    closePopup();
                }
            });
        }

        if (popupButton) {
            popupButton.addEventListener("click", function (e) {
                e.preventDefault();

                const emailInput = document.getElementById("modish-popup-input-email");
                const urlInput = document.getElementById("modish-popup-input-url");

                const emailValue = emailInput ? emailInput.value.trim() : "";
                const urlValue = urlInput ? urlInput.value.trim() : "";

                if (urlValue) {
                    window.location.href =
                        urlValue +
                        (urlValue.indexOf("?") > -1 ? "&" : "?") +
                        "email=" +
                        encodeURIComponent(emailValue);
                } else {
                    window.location.href = "/a/loyalty?email=" + encodeURIComponent(emailValue);
                }
            });
        }
    }

    const xhr = new XMLHttpRequest();

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState !== 4) return;

        let jsonResponse = {};

        try {
            jsonResponse = JSON.parse(this.responseText);
        } catch (error) {
            console.error("Popup response is not valid JSON", error, this.responseText);
            return;
        }

        if (!jsonResponse.status) return;
        if (shouldHideByPageVisibility(jsonResponse.page_visibility)) return;
        if (shouldHideByMemberVisibility(jsonResponse.member_visibility, jsonResponse.member_check)) return;

        const config = {
            useCookies: Number(jsonResponse.frequency) === 1,
            image: jsonResponse.image
                ? "https://dialog.modish.no/" + jsonResponse.image
                : "https://cdn.shopify.com/s/files/1/0079/5636/5423/files/PHOTO-2024-02-05-13-57-21.jpg?v=1710677624",
            backgroundColor: jsonResponse.background_color || "#ffffff",
            headerTextColor: jsonResponse.header_text_color || "#000000",
            headerTextSize: jsonResponse.header_text_size || 20,
            headerText: jsonResponse.header_text || "",
            description: jsonResponse.description || "",
            buttonUrl: jsonResponse.button_url || "",
            emailPlaceholder: jsonResponse.email_placeholder || "",
            emailBgColor: jsonResponse.email_background_color || "#f7f7f7",
            emailBorderColor: jsonResponse.email_border_color || "#000000",
            buttonBgColor: jsonResponse.button_background_color || "#000000",
            buttonTextColor: jsonResponse.button_text_color || "#ffffff",
            buttonText: jsonResponse.button_text || ""
        };

        const oldPopup = document.getElementById("modish-popup");
        if (oldPopup) {
            oldPopup.remove();
        }

        if (popupContainer) {
            popupContainer.innerHTML = buildPopupHtml(config);
        }

        applyDynamicStyles(config);
        bindPopupEvents();

        setTimeout(function () {
            showPopup(config.useCookies);
        }, 1000);
    });

    xhr.open("POST", "https://dialog.modish.no/api/popup-attributes");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(requestData);
});